// extracted by mini-css-extract-plugin
export default {"wrapperLabel":"xTxNd","expanded":"VMF5A","iconArrow":"e_K9y","termsContainer":"dzq2H","term":"T5cAb","title":"tOjG_"};